module.exports = __webpack_public_path__ + "static/img/knives31.b5f192c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives31.jpg
// module id = AZd7
// module chunks = 0